import { ALL_SUPPORTED_CATEGORY_TYPES_V2, ALL_TILE_ITEM_TYPES, TILE_LAYOUT_TYPE } from 'src/consumer/constants'
import { getCorrectUsableItemType } from '../../tile-carousels-utils'
import { SquareMid } from '../../tile-classes'

const SQUARE_MID_TILE_LOGIC_SETTERS = {
  [getCorrectUsableItemType(ALL_TILE_ITEM_TYPES.activityPlan)]: setActivityPlanTileItemLogic,
  [getCorrectUsableItemType(ALL_TILE_ITEM_TYPES.userMeditation)]: setPracticeTimerTileItemLogic,
}

const SQUARE_MID_TILE_LOGIC_SETTER_FOR_CATEGORY_TYPE = {
  [ALL_SUPPORTED_CATEGORY_TYPES_V2.activePlans]: setActivePlanCategoryTypeLogic,
}

export function getSquareMidLogic(itemType, tileData, { navigate }) {
  const tileLogicData = new SquareMid({ tileData })
  const carouselMakerFunction = SQUARE_MID_TILE_LOGIC_SETTERS?.[tileLogicData?.currentItemType]

  carouselMakerFunction &&
    carouselMakerFunction(tileLogicData, {
      navigate,
    })
  return tileLogicData
}

function setActivityPlanTileItemLogic(tileItemLogic, { navigate }) {
  let defaultTileItemLogicWithTileData = tileItemLogic
  const currentItemType = defaultTileItemLogicWithTileData.currentItemType

  let getSecondaryText = (item) => 'Activity Plan'

  let onClickLogic = (item) => {
    const currentItem = item?.[currentItemType]
    navigate(!!currentItem?.slug ? `/plan/${currentItem?.slug}` : `/plan/id/${currentItem?.id}`)
  }

  defaultTileItemLogicWithTileData.setTitleField((item) => {
    return item?.[currentItemType]?.title
  })
  defaultTileItemLogicWithTileData.setMainImage((item) => item?.[currentItemType]?.coverIcon)
  defaultTileItemLogicWithTileData.setSecondaryCardImage((item) => item?.coverIcon)
  defaultTileItemLogicWithTileData.setSecondaryTextFunction(getSecondaryText)
  defaultTileItemLogicWithTileData.setActionButtonLogic((item) => ({
    text: 'Start',
    onClick: onClickLogic,
  }))

  if (
    SQUARE_MID_TILE_LOGIC_SETTER_FOR_CATEGORY_TYPE[
      defaultTileItemLogicWithTileData?.currentCategoryType
    ]
  ) {
    SQUARE_MID_TILE_LOGIC_SETTER_FOR_CATEGORY_TYPE?.[
      defaultTileItemLogicWithTileData?.currentCategoryType
    ](defaultTileItemLogicWithTileData, { navigate })
  }
}

function setActivePlanCategoryTypeLogic(tileItemLogic, { navigate }) {
  // const tileItemLogic = Object.create(currentTileItemLogicObject)
  const currentItemType = tileItemLogic.currentItemType
  const currentTileData = tileItemLogic.tileData

  const onClickLogic = (item) =>
    navigate(`/my-activity/${item?.[currentItemType]?.slug}`, {
      state: { planId: item?.[currentItemType]?.id, slug: item?.[currentItemType]?.slug },
    })

  // tileItemLogic.setSecondaryItemsFunction((item) => createActivityPlanWithEstimatedCompletionDates(item?.[currentItemType],item?.))
  tileItemLogic.setSecondaryTextFunction((item) => item?.[currentItemType]?.description)

  currentTileData?.layout === TILE_LAYOUT_TYPE.squareMid &&
    tileItemLogic.setSecondaryTextFunction((item) => 'Active Plan')

  tileItemLogic.setActionButtonLogicFunction((item) => {
    return {
      text: 'Continue',
      onClick: onClickLogic,
    }
  })
  // tileItemLogic.getSecondaryItemViewType((secondaryItem)=>)

  return tileItemLogic
}

function setPracticeTimerTileItemLogic(tileItemLogic, { navigate }) {
  let defaultTileItemLogicWithTileData = tileItemLogic
  const currentItemType = defaultTileItemLogicWithTileData.currentItemType

  let getSecondaryText = (item) => 'Timer'

  let onClickLogic = (item) => {
    const mainItem = item?.[currentItemType]
    navigate(
      !!mainItem?.[mainItem?.itemField]?.title
        ? `/timer/${mainItem?.[mainItem?.itemField]?.slug}`
        : `/timer/id/${mainItem?.[mainItem?.itemField]?.id}`,
      {
        state: { item: mainItem?.[mainItem?.itemField] },
      },
    )
  }

  defaultTileItemLogicWithTileData.setTitleField((item) => {
    const mainItem = item?.[currentItemType]
    return mainItem?.[mainItem?.itemField]?.title
  })
  defaultTileItemLogicWithTileData.setMainImage((item) => {
    const mainItem = item?.[currentItemType]
    return mainItem?.[mainItem?.itemField]?.coverIcon
  })
  defaultTileItemLogicWithTileData.setSecondaryCardImage((item) => {
    const mainItem = item?.[currentItemType]
    return mainItem?.[mainItem?.itemField]?.coverImage
  })
  defaultTileItemLogicWithTileData.setSecondaryTextFunction(getSecondaryText)
  defaultTileItemLogicWithTileData.setActionButtonLogic((item) => ({
    text: 'Start',
    onClick: onClickLogic,
  }))

  if (
    SQUARE_MID_TILE_LOGIC_SETTER_FOR_CATEGORY_TYPE[
      defaultTileItemLogicWithTileData?.currentCategoryType
    ]
  ) {
    SQUARE_MID_TILE_LOGIC_SETTER_FOR_CATEGORY_TYPE?.[
      defaultTileItemLogicWithTileData?.currentCategoryType
    ](defaultTileItemLogicWithTileData, { navigate })
  }
}
